import React from 'react';
import { Outlet } from 'react-router-dom';

import './csv-styles.scss';

function CsvPage() {
  return (
    <div className="h-100 csv__main-container">
      <Outlet />
    </div>
  );
}

export default CsvPage;
